export type Types = 'string' | 'number' | 'boolean' | 'undefined' | 'null' | 'date' | 'object' | 'array';

const getTypeof = (obj: unknown): Types => {
  let type: string = typeof obj;
  if (type === 'object') {
    type = Object.prototype.toString
      .call(obj)
      .replace(/^\[object (\S+)\]$/, '$1')
      .toLocaleLowerCase();
  }
  return type as Types;
};

export const isNumber = (input: unknown): input is number => {
  return getTypeof(input) === 'number';
};

export const isString = (input: unknown): input is string => {
  return getTypeof(input) === 'string';
};

export const isObject = (input: unknown): input is object => {
  return getTypeof(input) === 'object';
};

export default getTypeof;
